import React, { useEffect, useState } from 'react';
import {
  getIPSProjectAssets,
  ipsAssetInstallationExcelDownload,
} from '../../../api';
import { Col, Row, Table } from 'antd';
import './assettable.css';

import IPSDTAssetFileExport from './IPSDTAssetFileExport';

function AssetInstall({ project,
  
}) {
  const [assets, setAssets] = useState([]);

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [refresh, setRefresh] = useState(true);
  let projectInfo = {
    bpid: project.bpid,
    workOrder: project.workOrder,
    stationName: project.stationName,
  };
  useEffect(() => {
    async function getData() {
     
  
      let assets = await getIPSProjectAssets(projectInfo);

      setAssets(assets);

      setRefresh(false);
     
    }

       if (refresh) getData();


  }, [refresh]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  function composeFilters(fieldName) {
    let filters = [...new Set(assets.map((asset) => asset[fieldName]))];
    let filtersSort = filters.map((distinctFilters) => ({
      text: distinctFilters,
      value: distinctFilters,
    }));
    filtersSort.sort((a, b) => {
      a = a.text || '';
      b = b.text || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });

    return filtersSort;
  }

  function multipleSort(compFunctions) {
    return function (a, b) {
      for (const func of compFunctions) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
    };
  }

  const iPSComp = (a, b) => {
    a = a.ipsLocationName || '';
    b = b.ipsLocationName || '';

    return b.localeCompare(a);
  };
  const assetNameComp = (a, b) => {
    a = a.assetName || '';
    b = b.assetName || '';

    return b.localeCompare(a);
  };

  const columns = [
    {
      dataIndex: 'assetName',
      width: '15%',
      key: 'assetName',
      title: 'Asset Name',
      filters: composeFilters('assetName'),
      fixed: 'left',
      filteredValue: filteredInfo.assetName || null,
      onFilter: (value, record) => record.assetName === value,
      sorter: (a, b) => {
        a = a.assetName || '';
        b = b.assetName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetGroupName',
      width: '7%',
      key: 'assetGroupName',
      title: 'Asset Group',
      filters: composeFilters('assetGroupName'),
      filteredValue: filteredInfo.assetGroupName || null,
      onFilter: (value, record) => record.assetGroupName === value,
      sorter: (a, b) => {
        a = a.assetGroupName || '';
        b = b.assetGroupName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetGroupName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetType',
      width: '12%',
      key: 'assetType',
      title: 'Asset Type',
      filters: composeFilters('assetType'),
      filteredValue: filteredInfo.assetType || null,
      onFilter: (value, record) => record.assetType === value,
      sorter: (a, b) => {
        a = a.assetType || '';
        b = b.assetType || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetType' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'ipsLocationName',
      width: '25%',
      key: 'ipsLocationName',
      title: 'IPS Location',
      filters: composeFilters('ipsLocationName'),
      filteredValue: filteredInfo.ipsLocationName || null,
      onFilter: (value, record) => record.ipsLocationName === value,
      sorter: (a, b) => {
        a = a.ipsLocationName || '';
        b = b.ipsLocationName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'ipsLocationName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'identityRespblty',
      width: '8%',
      key: 'identityRespblty',
      title: 'SE/PCE',
      filters: composeFilters('identityRespblty'),
      filteredValue: filteredInfo.identityRespblty || null,
      onFilter: (value, record) => record.identityRespblty === value,
      sorter: (a, b) => {
        a = a.identityRespblty || '';
        b = b.identityRespblty || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'identityRespblty' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    
    {
      dataIndex: 'workOrder',
      width: '8%',
      key: 'workOrder',
      title: 'Install WO#',
      filters: composeFilters('workOrder'),
      filteredValue: filteredInfo.workOrder || null,
      onFilter: (value, record) => record.workOrder === value,
      sorter: (a, b) => {
        a = a.workOrder || '';
        b = b.workOrder || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'workOrder' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'bpid',
      width: '8%',
      key: 'bpid',
      title: 'Install BPID',
      filters: composeFilters('bpid'),
      filteredValue: filteredInfo.bpid || null,
      onFilter: (value, record) => record.bpid === value,
      sorter: (a, b) => {
        a = a.bpid || '';
        b = b.bpid || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'bpid' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'internalRef',
      width: '10%',
      key: 'internalRef',
      title: 'IPS Internal Ref. No.',
      filters: composeFilters('internalRef'),
      filteredValue: filteredInfo.internalRef || null,
      onFilter: (value, record) => record.internalRef === value,
      sorter: (a, b) => {
        a = a.internalRef || '';
        b = b.internalRef || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'internalRef' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetStatus',
      width: '8%',
      key: 'assetStatus',
      title: 'IPS Asset Status',
      filters: composeFilters('assetStatus'),
      filteredValue: filteredInfo.assetStatus || null,
      onFilter: (value, record) => record.assetStatus === value,
      sorter: (a, b) => {
        a = a.assetStatus || '';
        b = b.assetStatus || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetStatus' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
  ];

  return (
    <div className='container-fluid'>
      {/*<b>{this.state.project.stationName}</b>*/}
      <Row xs={24} style={{ alignItems: 'center', margin: '8px 0px' }}>
        <Col xs={18}>
          Here are the assets pulled for this project. Please review, and if
          there are any discrepancies, fix in IPS.
        </Col>
        <Col xs={6}>
          <h4>
            <IPSDTAssetFileExport
              
              projectInfo={projectInfo}
              station={project.stationName}
              apiCall={ipsAssetInstallationExcelDownload}
              fileStartingName={'IPSAssets '}
            />
          </h4>
        </Col>
      </Row>
      <Table
        className={'table-striped'}
        columns={columns}
        dataSource={assets.sort(multipleSort([iPSComp, assetNameComp]))}
        onChange={handleChange}
        loading={ refresh}

        pagination={{ showSizeChanger: false, pageSize: 10 }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}

export default AssetInstall;
